export const BetStatusList = [
  { id: "", name:"All Status" },
  { id: "OPEN", name: "Open" },
  { id: "SETTLED", name: "Settled" },
  { id: "VOIDED", name: "Voided" },
  { id: "CASHOUT-SETTLEMENT", name: "Cashed Out" },
  { id: "BLOCKED", name: "Blocked" },
  { id: "UNMATCHED", name: "Unmatched" },
  { id: "TIMELY_VOIDED", name: "Timely Voided" },
  { id: "CANCELLED", name: "Cancelled" },
  { id: "DELETED", name: "Delete" },
  { id: "EXPIRED", name: "Expired" },
  { id: "LAPSED", name: "Lapsed" },
  { id: "SETTLED_VOIDED", name: "Settled Voided" },
];

export const BetsStatusList = [
  { id: "", name:"All Status" },
  { id: "OPEN", name: "Open" },
  { id: "SETTLED", name: "Settled" },
  { id: "VOIDED", name: "Voided" },
  { id: "BLOCKED", name: "Blocked" },
  { id: "FLAGGED", name: "Flagged" },
  { id: "CASHOUT-SETTLEMENT", name: "Cashed Out" },
  { id: "OPEN-failed", name: "Open Failed" },
  { id: "ROPEN-failed", name: "Re-Open Failed" },
  { id: "SETTLED-failed", name: "Settled Failed" },
  { id: "RSETTLED-failed", name: "Re-Settled Failed" },
  { id: "RCASHOUT-SETTLEMENT-failed", name: "Cashed Out Failed" },
  { id: "UNMATCHED", name: "Unmatched" },
  { id: "CANCELLED", name: "Cancelled" },
  { id: "DELETED", name: "Delete" },
  { id: "EXPIRED", name: "Expired" },
  { id: "LAPSED", name: "Lapsed" },
  { id: "SETTLED_VOIDED", name: "Settled Voided" },
  { id: "TIMELY_VOIDED", name: "Timely Voided" },
];

export const BetMonitorStatusList = [
  { id: "OPEN", name: "Open" },
  { id: "SETTLED", name: "Settled" },
  { id: "VOIDED", name: "Voided" },
];

export const TransactionTypes = ["FUNDS", "BETS"];

export const SPORT_FILTER_OPTIONS = [
  { id: "all", name: "All" },
  { id: "4", name: "Cricket" },
  { id: "1", name: "Football / Soccer" },
  { id: "2", name: "Tennis" },
];

export const SRBetStatusList = [
  { id: "", name:"All Status" },
  { id: "OPEN", name: "Open" },
  { id: "SETTLED", name: "Settled" },
  { id: "VOIDED", name: "Voided" },
  // { id: "SETTLED_OPEN", name: "Settled Open" },
];

export const RiskBetsStatus = [
  { id: "OPEN", name: "Settled Open" },
  { id: "BLOCKED", name: "Blocked" },
];
